var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUserPic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30.001,
    viewBox: "0 0 30 30.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pro_Pic",
    "data-name": "Pro Pic",
    transform: "translate(5000.315 3917.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path454",
    d: "M1122.685-782.055A14.959,14.959,0,0,1,1118-771.162a14.617,14.617,0,0,1-1.252,1.06c-.072.057-.144.111-.218.164q-.319.235-.653.451c-.034.022-.067.044-.1.065s-.054.036-.082.053q-.533.337-1.1.629a14.574,14.574,0,0,1-1.6.718l-.156.058a14.86,14.86,0,0,1-4.014.865h-.019c-.225.017-.451.029-.679.035l-.126,0h-.05l-.263,0c-.11,0-.218,0-.328-.006h-.014c-.048,0-.1,0-.146,0-.067,0-.135,0-.2-.007-.232-.01-.463-.025-.69-.047a14.83,14.83,0,0,1-3.126-.625c-.335-.106-.665-.222-.989-.35a14.893,14.893,0,0,1-1.621-.753q-.515-.277-1-.593a14.9,14.9,0,0,1-1.705-1.279l-.04-.036c-.035-.031-.07-.06-.1-.092q-.142-.125-.279-.254a14.959,14.959,0,0,1-4.753-10.955,15,15,0,0,1,15-15,15,15,0,0,1,15,15",
    transform: "translate(-6093 -3120.335)",
    fill: "#f7f2da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path456",
    d: "M1252.251-605.64c-.026.018-.054.036-.082.053l.068-.077.014.024",
    transform: "translate(-6229.477 -3284.116)",
    fill: "#d1e3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path458",
    d: "M1146.343-631.723c-.033.022-.067.044-.1.065s-.054.036-.082.053q-.534.337-1.1.629a14.607,14.607,0,0,1-1.6.718l-.156.058a14.866,14.866,0,0,1-4.014.865h-.019c-.225.017-.451.029-.679.035l-.126,0h-.05l-.263,0c-.11,0-.218,0-.328-.006h-.014c-.048,0-.1,0-.146,0-.067,0-.135,0-.2-.007q-.348-.014-.69-.047a14.824,14.824,0,0,1-3.126-.625c-.335-.106-.665-.222-.989-.35a14.888,14.888,0,0,1-1.621-.753q-.515-.277-1-.593a14.921,14.921,0,0,1-1.705-1.279l-.04-.036c.129-.112.259-.223.389-.33l0,0c.239-.2,2.877-1.2,4.258-1.747l.153-.061.049-.019h0c.307-.125.525-.217.6-.258a2.6,2.6,0,0,1,.42-.181h0a10.121,10.121,0,0,1,1.819-.4h0c.15-.019.282-.036.39-.048h0c.181-.021.292-.031.292-.031a9.352,9.352,0,0,1,2.822.561l.033.018c.028.015.067.036.117.06h0c.2.1.56.254,1.006.446h0c.246.107.515.224.8.345h0l.035.015h0l.3.129h0c1.189.513,2.507,1.088,3.081,1.4h0a1.72,1.72,0,0,1,.254.161c.111.1.22.2.33.3.207.192.408.388.6.585.1.107.2.214.29.321",
    transform: "translate(-6123.468 -3258.099)",
    fill: "#fcfbfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path460",
    d: "M1186.642-628.943a12.024,12.024,0,0,1,7.487,1.571,16.31,16.31,0,0,1,1.783,1.187c-.187-.2-.388-.394-.6-.586q-.163-.15-.33-.3a13.58,13.58,0,0,0-3.784-1.738,11.706,11.706,0,0,0-4.559-.325c-.118.015-.12.2,0,.186",
    transform: "translate(-6173.327 -3263.957)",
    fill: "#d1e3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path462",
    d: "M1197.546-616.722l-.126,0h-.05c0-1.073-.014-2.146-.066-3.215-.005-.126-.012-.253-.019-.379-.01-.167-.021-.333-.039-.5-.007-.065-.014-.129-.024-.193-.011-.083-.024-.167-.039-.25-.021-.118.159-.168.181-.05s.042.253.057.38a.354.354,0,0,1,.005.053c.025.2.04.4.052.595.021.34.029.683.039,1.021.011.362.018.726.024,1.09v0c.006.479.007.96.006,1.439",
    transform: "translate(-6182.422 -3270.675)",
    fill: "#d1e3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path464",
    d: "M1194.732-618.9a1.346,1.346,0,0,0-.018-.326l.145-.093.129-.083.046-.029.279-.179.008-.006.018-.011c.022.111.043.228.064.351s.04.254.061.39c.145.975.268,2.245.374,3.621-.225.017-.451.029-.679.035l-.126,0h-.05l-.262,0c-.11,0-.218,0-.328-.006.194-1.654.332-3.039.34-3.671",
    transform: "translate(-6180.035 -3272.17)",
    fill: "#4c4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path466",
    d: "M1199.655-616.688h-.019c-.225.017-.451.029-.679.035l-.126,0c.043-.5.085-.986.121-1.442v0c.067-.832.118-1.568.146-2.139.008-.178.015-.339.019-.482,0-.121,0-.229,0-.322s0-.171-.008-.233l.026-.018c.036.182.069.383.1.6.018.117.036.239.054.365.139,1,.258,2.272.361,3.638",
    transform: "translate(-6183.833 -3270.745)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path468",
    d: "M1191.262-630.925c0,.57.523,1.591,1.169,1.591a.973.973,0,0,0,.72-.432,2.109,2.109,0,0,0,.449-1.159,1.107,1.107,0,0,0-1.169-1.032,1.3,1.3,0,0,0-.425.07,1.044,1.044,0,0,0-.744.962",
    transform: "translate(-6177.357 -3261.616)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path470",
    d: "M1191.262-630.509c0,.57.523,1.592,1.169,1.592a.973.973,0,0,0,.72-.432l-.091-.01c-.238-.031-.748-.091-.911-.293a1.827,1.827,0,0,1-.155-.847,6.685,6.685,0,0,1,.012-.97,1.044,1.044,0,0,0-.744.962",
    transform: "translate(-6177.357 -3262.033)",
    fill: "#4c4c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path472",
    d: "M1130.8-629.752l-.135.083-1.318.811-.049.19-.469,1.875q0,.152,0,.3c-.008.268-.029.539-.062.81q-.515-.277-1-.593a14.913,14.913,0,0,1-1.705-1.279l-.04-.036c-.035-.031-.07-.06-.1-.091q-.142-.125-.279-.254a9.29,9.29,0,0,1,5.169-1.82",
    transform: "translate(-6121.193 -3263.503)",
    fill: "#fcfbfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path474",
    d: "M1133.619-624.661c-.139-.006-.277-.011-.417-.011a.593.593,0,0,0-.085,0h0a11.635,11.635,0,0,0-2.163.192,11.572,11.572,0,0,0-1.79.482,11.831,11.831,0,0,0-1.454.635l-.04-.036c-.035-.031-.07-.06-.1-.091.162-.083.328-.164.493-.239a12.235,12.235,0,0,1,2.945-.94,11.54,11.54,0,0,1,1.961-.187h.079c.192,0,.383,0,.576.014.119.006.121.192,0,.186",
    transform: "translate(-6122.849 -3267.689)",
    fill: "#d1e3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path476",
    d: "M1170.3-668.768a7.118,7.118,0,0,1,1.328-1.351,6.749,6.749,0,0,1,1.115,1.327c.711-.14,1.153-.436,1-.944a11.612,11.612,0,0,1-.274-1.42c-.036-.243-.07-.5-.1-.775-.266-2.174-.465-5-.465-5l-5.44-.155s.024.311.04.812c.013.4.02.908.007,1.478-.04,1.674.189,3.483-.615,4.616-.32.45,1.847,1.236,3.407,1.416",
    transform: "translate(-6156.473 -3222.995)",
    fill: "#ffb884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path478",
    d: "M1171.3-673.879a8.56,8.56,0,0,0,3.779,2.722,5.505,5.505,0,0,0,2-.519c-.266-2.174-.387-4.338-.387-4.338h-4.758l-.643.656c.013.4.02.908.007,1.478",
    transform: "translate(-6160.269 -3223.915)",
    fill: "#ef9c62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path480",
    d: "M1220.424-709.551a1.174,1.174,0,0,0-.721.1c-.249.072-.617.178-.633.485a4.535,4.535,0,0,0,.126.776l.336,1.5a.915.915,0,0,0,.57-.1,7.971,7.971,0,0,0,.527-2.168c.017-.267.08-.475-.2-.588",
    transform: "translate(-6201.152 -3195.189)",
    fill: "#ffb884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path482",
    d: "M1221.659-707.81c-.08-.194-.313-.084-.481-.041s-.462.086-.571.242.006.554.046.749c.417-.18.507.49.129.506l.017.123a1.412,1.412,0,0,0,.128.465c-.018-.128-.1-.375-.028-.485s.258-.109.341-.215c.217-.276-.144-.5-.4-.527a1.263,1.263,0,0,1-.018-.392c.042-.093.234-.145.33-.191.144-.068.234-.149.329-.03a.754.754,0,0,1,.068.343.972.972,0,0,0,.108-.546",
    transform: "translate(-6202.429 -3196.611)",
    fill: "#ef9c62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path484",
    d: "M1169.465-737.048a2.472,2.472,0,0,1,.143-2.132.972.972,0,0,1,.187-.18,10.135,10.135,0,0,1,2.572-1.39v-.006h.015l.015-.005v.007a10.133,10.133,0,0,1,2.85.654.964.964,0,0,1,.228.124,2.472,2.472,0,0,1,.707,2.017c-.067,1.045,1.8,4.773,1.553,6.533-.077.543-1.356,2-2.1,3.573-.16.336-1.03.564-1.411.63-.005,0-1.261.028-1.528-.231a26.17,26.17,0,0,1-2.981-2.883c-.711-1.629.1-5.721-.246-6.711",
    transform: "translate(-6158.555 -3168.509)",
    fill: "#ffb884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path486",
    d: "M1164.761-750.681a7.756,7.756,0,0,0,.568,1.782c.218-1.019.493-5.3,1.681-4.391.828.631,1.591,1.984,2.769,1.533.412-.158.486-.387.836-.869.916-1.261,1.036,1.055,1.74,2.53,0,0,.066-.411.157-.909a13.35,13.35,0,0,1,.366-1.631c.29-.767.735-1.109.7-1.935-.108-2.345-.741-2.61-3.053-3.163.393,1.9-3.212,1.217-4.047,1.562-1.193.493-1.946.91-2.323,1.81-.353.842.371,2.469.611,3.682",
    transform: "translate(-6154.074 -3153.984)",
    fill: "#874410"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path488",
    d: "M1171.388-730.017c.218-1.019.493-5.3,1.681-4.391.828.631,1.591,1.984,2.769,1.533.413-.158.486-.387.836-.869.916-1.261,1.036,1.055,1.74,2.53,0,0,.066-.411.157-.909-.393-.752-.331-2.45-1.379-2.656-.516-.1-.83.236-1.284.43a1.447,1.447,0,0,1-1.171-.087c-.454-.256-.905-.547-1.337-.84-.549-.373-1.029-.615-1.559-.093a3.464,3.464,0,0,0-.688,1.832,20.619,20.619,0,0,0,.236,3.52",
    transform: "translate(-6160.134 -3172.865)",
    fill: "#6d340d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path490",
    d: "M1161.648-707.8a1.174,1.174,0,0,1,.727-.005c.257.037.636.091.695.392a4.535,4.535,0,0,1-.017.787l-.124,1.531a.917.917,0,0,1-.578-.02,7.958,7.958,0,0,1-.823-2.073c-.054-.262-.146-.46.12-.611",
    transform: "translate(-6151.86 -3196.66)",
    fill: "#ffb884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path492",
    d: "M1163.28-706.094c.053-.2.3-.127.471-.108s.47.021.6.16.071.549.058.748c-.437-.12-.434.556-.058.519v.124a1.414,1.414,0,0,1-.062.479c0-.129.045-.385-.04-.484s-.271-.072-.368-.165c-.253-.243.073-.514.322-.578a1.274,1.274,0,0,0-.037-.391c-.055-.087-.252-.112-.354-.143-.152-.048-.252-.115-.33.016a.755.755,0,0,0-.02.349c-.073-.121-.219-.387-.183-.526",
    transform: "translate(-6153.407 -3198.056)",
    fill: "#ef9c62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path494",
    d: "M1207.1-702.3a5.861,5.861,0,0,1,1.368.088c.1.02.221.024.276.124a1.951,1.951,0,0,1,.144.4,1.045,1.045,0,0,1,0,.177,3.656,3.656,0,0,0-1.455-.139c-.19.046-.516.468-.547.475a6.441,6.441,0,0,1,.214-1.121",
    transform: "translate(-6190.728 -3201.409)",
    fill: "#e89258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path496",
    d: "M1208.989-699.614s-.182.329-.873.329-.872-.329-.872-.329-.072.035-.09.012.073-.077.083-.15.162-.642.338-.7,1.271-.053,1.437.193-.023.641-.023.641",
    transform: "translate(-6190.955 -3202.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path498",
    d: "M1208.815-700.187h0a.925.925,0,0,1-.025.146.991.991,0,0,1-.061.178s-.182.307-.837.307-.838-.307-.839-.31l-.018-.032-.032.015a.2.2,0,0,0,.047-.1l.005-.031c.01-.044.029-.115.056-.193.061-.185.16-.414.25-.442a1.824,1.824,0,0,1,.374-.027c.039,0,.079,0,.119,0h0a3.846,3.846,0,0,1,.41.032.818.818,0,0,1,.49.171.434.434,0,0,1,.06.279m.078-.083a.464.464,0,0,0-.075-.239l-.025-.029-.043-.035a.451.451,0,0,0-.054-.032.755.755,0,0,0-.071-.031l-.056-.018a1.978,1.978,0,0,0-.293-.06l-.083-.011c-.2-.021-.39-.024-.458-.024a1.817,1.817,0,0,0-.4.031c-.154.047-.276.393-.332.592-.019.071-.03.124-.033.138a.17.17,0,0,1-.049.079.166.166,0,0,0-.032.047h0l0,.024.01.023a.067.067,0,0,0,.051.022.253.253,0,0,0,.056-.01,1.048,1.048,0,0,0,.886.319c.7,0,.9-.335.906-.349s.023-.051.046-.118a1.055,1.055,0,0,0,.043-.181v-.006l0-.039h0s0-.022,0-.053v-.047",
    transform: "translate(-6190.729 -3202.75)",
    fill: "#e89258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path500",
    d: "M1211.286-699.9a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5",
    transform: "translate(-6194.492 -3203.044)",
    fill: "#3a2e26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path502",
    d: "M1214.522-698.172a.209.209,0,0,0,.209.209.209.209,0,0,0,.209-.209.209.209,0,0,0-.209-.209.209.209,0,0,0-.209.209",
    transform: "translate(-6197.261 -3204.775)",
    fill: "#4c3f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path504",
    d: "M1214.031-697.349a.071.071,0,0,0,.071.071.071.071,0,0,0,.071-.071.071.071,0,0,0-.071-.071.071.071,0,0,0-.071.071",
    transform: "translate(-6196.841 -3205.597)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path506",
    d: "M1220.437-696.875h0l.006-.018-.006.018m.043-.182v0l0-.039h0s0-.026,0-.06h0a.773.773,0,0,1-.008.1",
    transform: "translate(-6202.323 -3205.82)",
    fill: "#e5a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path508",
    d: "M1217.124-699.963h0s0-.022,0-.053v-.006c0,.033,0,.06,0,.06m0-.1h0s0,0,0-.006,0,0,0,.006m0-.048h0m0,0a.446.446,0,0,0-.07-.188l-.025-.029-.043-.035a.449.449,0,0,0-.054-.032l-.052-.023a.369.369,0,0,1,.175.119.439.439,0,0,1,.069.188m-.271-.317-.034-.011.034.011m-.048-.016h0a1.984,1.984,0,0,0-.292-.06,1.936,1.936,0,0,1,.293.06",
    transform: "translate(-6198.962 -3202.956)",
    fill: "#d0834f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path510",
    d: "M1210.109-699.578a.893.893,0,0,0-.278-.271.5.5,0,0,0-.248-.326h0a.818.818,0,0,1,.49.171.435.435,0,0,1,.06.279h0a.94.94,0,0,1-.025.146h0m-1.679-.163c.061-.185.159-.414.25-.441a1.815,1.815,0,0,1,.374-.027c.039,0,.079,0,.119,0h0a.5.5,0,0,0-.287.265,1.438,1.438,0,0,0-.456.2",
    transform: "translate(-6192.048 -3203.21)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path512",
    d: "M1209.544-699.94a.9.9,0,0,0-.053-.094h0a.938.938,0,0,0,.025-.146h0a.434.434,0,0,0-.06-.279.818.818,0,0,0-.49-.171h0a.5.5,0,0,0-.24-.061.5.5,0,0,0-.17.03h-.12a1.818,1.818,0,0,0-.374.026c-.09.028-.189.257-.25.441h0a1.291,1.291,0,0,0-.1.077c.056-.2.177-.544.332-.592a1.776,1.776,0,0,1,.4-.03,4.34,4.34,0,0,1,.542.034,1.97,1.97,0,0,1,.293.06h0l.014,0,.034.011.026.01.052.023a.44.44,0,0,1,.054.032l.043.035.025.029a.447.447,0,0,1,.07.188v0h0c0,.014,0,.028,0,.042s0,0,0,.006h0c0,.013,0,.026,0,.04h0v.006c0,.031,0,.053,0,.053h0l0,.039v0a1.04,1.04,0,0,1-.037.164l-.005.017",
    transform: "translate(-6191.43 -3202.754)",
    fill: "#d0834f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path514",
    d: "M1212.538-700.016a1.013,1.013,0,0,0-.543-.141,1.644,1.644,0,0,0-.4.048.5.5,0,0,1,.287-.265.5.5,0,0,1,.17-.03.5.5,0,0,1,.24.061.5.5,0,0,1,.248.326",
    transform: "translate(-6194.755 -3203.044)",
    fill: "#342922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path516",
    d: "M1180.12-700.916a5.866,5.866,0,0,0-1.368.087c-.1.02-.221.024-.276.124a1.949,1.949,0,0,0-.144.4,1.07,1.07,0,0,0,0,.177,3.66,3.66,0,0,1,1.455-.139c.19.046.516.468.547.475a6.462,6.462,0,0,0-.214-1.121",
    transform: "translate(-6166.289 -3202.59)",
    fill: "#e89258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path518",
    d: "M1178.7-698.234s.182.33.873.33.872-.33.872-.33.072.035.09.012-.073-.077-.083-.15-.162-.642-.338-.7-1.271-.053-1.437.193.023.641.023.641",
    transform: "translate(-6166.525 -3204.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path520",
    d: "M1180.182-698.48s-.182.31-.839.31-.837-.307-.837-.307a.909.909,0,0,1-.061-.177.915.915,0,0,1-.025-.147.44.44,0,0,1,.06-.28c.088-.128.507-.192.9-.2h.12c.1,0,.19,0,.255.01a.668.668,0,0,1,.118.018c.09.028.189.256.25.44.026.079.046.15.056.195l.005.029a.2.2,0,0,0,.047.1l-.032-.017-.018.032m.161.007h0v0h0a.162.162,0,0,0-.032-.047.167.167,0,0,1-.049-.079c0-.014-.014-.065-.034-.136-.055-.2-.176-.544-.332-.592a1.719,1.719,0,0,0-.4-.031c-.154,0-.931.011-1.084.238a.438.438,0,0,0-.057.125l-.007.032-.005.033,0,.033v.033c0,.024,0,.046,0,.061l0,.022h0c0,.021,0,.042.007.061l.009.049a.942.942,0,0,0,.031.114,1.068,1.068,0,0,0,.046.118c.007.014.2.35.906.35a1.052,1.052,0,0,0,.887-.321.174.174,0,0,0,.054.011.064.064,0,0,0,.051-.022l.01-.025,0-.024",
    transform: "translate(-6166.3 -3203.935)",
    fill: "#e89258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path522",
    d: "M1184.307-698.542a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-6170.548 -3204.208)",
    fill: "#3a2e26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path524",
    d: "M1186.624-696.812a.209.209,0,0,1-.209.209.209.209,0,0,1-.209-.209.209.209,0,0,1,.209-.209.209.209,0,0,1,.209.209",
    transform: "translate(-6173.029 -3205.939)",
    fill: "#4c3f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path526",
    d: "M1185.94-695.9a.071.071,0,0,1-.071.071.071.071,0,0,1-.071-.071.071.071,0,0,1,.071-.071.07.07,0,0,1,.071.071",
    transform: "translate(-6172.681 -3206.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path528",
    d: "M1178.388-695.464a1.034,1.034,0,0,1-.048-.224h0c0,.021,0,.042.007.061l.009.049a.953.953,0,0,0,.03.114h0m-.048-.224c0-.018,0-.037,0-.055,0,.031,0,.055,0,.055",
    transform: "translate(-6166.296 -3207.032)",
    fill: "#e5a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path530",
    d: "M1178.339-697.452h0s0-.024,0-.055a.486.486,0,0,1,.075-.284l.01-.013-.01.013a.437.437,0,0,0-.057.125l-.007.032-.005.033,0,.033v.033c0,.024,0,.046,0,.061v.022h0",
    transform: "translate(-6166.296 -3205.268)",
    fill: "#d0834f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path532",
    d: "M1178.9-698.192h0a.9.9,0,0,1-.025-.147.44.44,0,0,1,.06-.28c.088-.128.507-.192.9-.2h0a.5.5,0,0,0-.261.225.9.9,0,0,0-.676.4h0",
    transform: "translate(-6166.751 -3204.397)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path534",
    d: "M1191.276-695.523h0l-.023-.079c.009.028.017.055.023.08",
    transform: "translate(-6177.349 -3207.153)",
    fill: "#d0834f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path536",
    d: "M1188.511-698.307l-.066-.042a.5.5,0,0,0-.3-.417h0a.666.666,0,0,1,.118.018c.09.028.189.256.25.44",
    transform: "translate(-6174.688 -3204.446)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path538",
    d: "M1184.072-699.172a.334.334,0,0,0-.162-.16,1.722,1.722,0,0,0-.4-.031,4.475,4.475,0,0,0-.482.027,4.5,4.5,0,0,1,.482-.027,1.783,1.783,0,0,1,.4.03.335.335,0,0,1,.161.161",
    transform: "translate(-6170.315 -3203.934)",
    fill: "#d0834f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path540",
    d: "M1178.392-698.561a.969.969,0,0,1-.03-.114l-.009-.049c0-.019-.005-.04-.007-.061h0v-.022c0-.015,0-.037,0-.061v-.033l0-.033.005-.033.007-.032a.437.437,0,0,1,.057-.125l.01-.013a1.013,1.013,0,0,1,.592-.2,4.489,4.489,0,0,1,.482-.027,1.719,1.719,0,0,1,.4.031.334.334,0,0,1,.162.16,1.774,1.774,0,0,1,.147.351c.009.028.016.055.023.079-.03-.025-.064-.051-.1-.077h0c-.061-.185-.16-.412-.25-.44a.668.668,0,0,0-.118-.018h0a.5.5,0,0,0-.2-.04.5.5,0,0,0-.177.032h0c-.394.011-.814.075-.9.2a.44.44,0,0,0-.06.28.915.915,0,0,0,.025.147h0a.989.989,0,0,0-.053.093",
    transform: "translate(-6166.3 -3203.935)",
    fill: "#d0834f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path542",
    d: "M1184.679-698.587a1.42,1.42,0,0,0-.23-.11.209.209,0,0,0-.142-.055l-.031,0a1.658,1.658,0,0,0-.389-.045,1.274,1.274,0,0,0-.144.008.5.5,0,0,1,.261-.225.5.5,0,0,1,.176-.032.5.5,0,0,1,.2.04.5.5,0,0,1,.3.417",
    transform: "translate(-6170.922 -3204.208)",
    fill: "#342922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path544",
    d: "M1187.61-696.966a1.522,1.522,0,0,0-.173-.053l.032,0a.209.209,0,0,1,.142.055",
    transform: "translate(-6174.083 -3205.939)",
    fill: "#443930"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path546",
    d: "M1206.024-709.183a5.96,5.96,0,0,1,1.868-.182l.095,0a2.371,2.371,0,0,0-.172-.416,1.048,1.048,0,0,0-.412-.189,8.69,8.69,0,0,0-1.134-.284,2.028,2.028,0,0,0-.17.65,3.841,3.841,0,0,1-.074.417",
    transform: "translate(-6189.989 -3194.618)",
    fill: "#874410"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path548",
    d: "M1206.023-706.939a5.964,5.964,0,0,1,1.868-.182c-.118-.037-.236-.064-.315-.084a2.915,2.915,0,0,0-.725-.164c-.021-.087-.026-.174-.049-.259a3.013,3.013,0,0,0-.2.276.517.517,0,0,0-.077-.261,1.8,1.8,0,0,0-.177.3c0-.021-.016-.066-.017-.094a.593.593,0,0,0-.231.048,3.815,3.815,0,0,1-.074.417",
    transform: "translate(-6189.988 -3196.862)",
    fill: "#6d340d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path550",
    d: "M1180.258-712.214a5.952,5.952,0,0,0-1.868-.182l-.094,0a2.365,2.365,0,0,1,.171-.416,1.049,1.049,0,0,1,.413-.189,8.618,8.618,0,0,1,1.134-.283,2.036,2.036,0,0,1,.17.65,3.757,3.757,0,0,0,.075.417",
    transform: "translate(-6166.261 -3192.024)",
    fill: "#874410"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path552",
    d: "M1180.818-709.969a5.958,5.958,0,0,0-1.869-.182c.118-.037.236-.064.315-.084a2.916,2.916,0,0,1,.725-.164c.021-.087.026-.174.049-.259a3,3,0,0,1,.2.276.518.518,0,0,1,.076-.261,1.807,1.807,0,0,1,.177.3c0-.021.016-.066.017-.094a.6.6,0,0,1,.231.048,3.729,3.729,0,0,0,.075.417",
    transform: "translate(-6166.82 -3194.269)",
    fill: "#6d340d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path554",
    d: "M1196.708-697.4c.4.008,2.216.658,1.336-.815a5.934,5.934,0,0,1-.306-2.038,7.576,7.576,0,0,1,.042-.853,9.85,9.85,0,0,0,.335,2.259c.139.343.285.68.451,1.012.085.169.124.214.046.39a1.14,1.14,0,0,1-1.634.334,1.176,1.176,0,0,1-.276.156.388.388,0,0,1,0-.444",
    transform: "translate(-6181.955 -3202.446)",
    fill: "#ef9c62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path556",
    d: "M1195.862-656.5a2.38,2.38,0,0,0,.631.151,1.214,1.214,0,0,0,.528-.02l.005,0a1.076,1.076,0,0,1-.256.254,1.706,1.706,0,0,1-.263.054.63.63,0,0,1-.479-.149c-.059-.094-.116-.189-.167-.287",
    transform: "translate(-6181.293 -3240.618)",
    fill: "#ef9c62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path558",
    d: "M1184.83-671.79a1.666,1.666,0,0,1,.382.527c.1.188.169.387.25.581a.678.678,0,0,0,.476.413c.265.028.529.082.79.125a2.41,2.41,0,0,0,1.075.081,2.774,2.774,0,0,0,.532-.647,1.768,1.768,0,0,1,.635-.548c-.707-.018-1.381-.089-1.628-.121-.712-.092-1.4-.182-2.107-.329-.116-.024-.262-.046-.405-.081",
    transform: "translate(-6171.853 -3227.53)",
    fill: "#60120f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path560",
    d: "M1183.21-673.65a2.66,2.66,0,0,1,.506.786l.007.016h0c.024.048.047.1.068.148.049.013.1.112.146.2.033.061.067.115.094.123a5.7,5.7,0,0,0,.654.148,6.281,6.281,0,0,0,1.426.155,1.153,1.153,0,0,0,.722-.374h0a4.229,4.229,0,0,0,.374-.421l.053-.066c-.086,0-.173-.007-.259-.014a18.593,18.593,0,0,1-2.263-.248c-.272-.039-.545-.087-.814-.148-.217-.037-.5-.258-.716-.3",
    transform: "translate(-6170.466 -3225.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path562",
    d: "M1189.24-667.851a3.865,3.865,0,0,0,1.008-.594l.01.027a4.267,4.267,0,0,1-.374.421h0a1.152,1.152,0,0,1-.722.374,6.29,6.29,0,0,1-1.427-.155,5.718,5.718,0,0,1-.654-.148c-.028-.009-.061-.063-.094-.123-.047-.084-.1-.183-.146-.2-.022-.05-.045-.1-.068-.148a17.49,17.49,0,0,0,2.468.542",
    transform: "translate(-6173.514 -3230.392)",
    fill: "#f4f0ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path564",
    d: "M1186.947-674.626c-.023.013-.047.027-.069.04l-.042.027a1.4,1.4,0,0,0-.177.142c-.025.024-.05.047-.074.072s-.044.046-.066.069-.049.054-.071.082l-.005.006-.006.007c-.021.023-.04.047-.058.071a2.751,2.751,0,0,1-.532.647,2.411,2.411,0,0,1-1.073-.081c-.261-.044-.525-.1-.79-.125a.681.681,0,0,1-.477-.412c-.015-.036-.029-.071-.043-.107h0v0c-.057-.144-.115-.287-.183-.428l-.022-.046a4.643,4.643,0,0,0-.285-.5h0c-.03-.047-.064-.092-.1-.135a4.132,4.132,0,0,0,.943.3l.011,0a13.481,13.481,0,0,0,2.574.375h.01c.046,0,.09,0,.133,0,.018,0,.036,0,.054,0a3.122,3.122,0,0,0,.415-.029A.625.625,0,0,0,1186.947-674.626Zm.428-.244a.485.485,0,0,0-.2-.113c.022.021.043.042.067.063a.081.081,0,0,1-.043.133,2.414,2.414,0,0,1-.5.04c-.086,0-.174-.007-.26-.014l-.032,0h-.01c-3.269-.281-3.532-.782-3.64-.874a.572.572,0,0,1,.247-.125c-.144.007-.314-.033-.414.118a.36.36,0,0,0,0,.332.189.189,0,0,1,.053-.144,2.645,2.645,0,0,1,.506.786l.008.017c.024.047.046.1.068.147.036.083.071.168.107.253a3.416,3.416,0,0,0,.218.442c.076.124.18.143.336.193a7.046,7.046,0,0,0,1.283.242c.346.064.7.134.913-.129.1-.129.229-.3.373-.471l.013-.014a1.556,1.556,0,0,1,.958-.654l.04.021a.453.453,0,0,0-.092-.244",
    transform: "translate(-6169.898 -3224.129)",
    fill: "#ef9c62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path566",
    d: "M1161.469-638.2s3.836,4.84,3.759,3.8a4.247,4.247,0,0,1,.457-2.38,7.116,7.116,0,0,1,1.328-1.35l-3.758-1.39-.4-.189-1.383,1.514",
    transform: "translate(-6151.861 -3254.978)",
    fill: "#d1e3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path568",
    d: "M1161.469-640.2s3.614,4.441,3.537,3.4a2.976,2.976,0,0,1,.679-1.905,7.12,7.12,0,0,1,1.328-1.351l-3.758-1.713-.4-.189-1.383,1.76",
    transform: "translate(-6151.861 -3253.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path570",
    d: "M1199.9-633.208a5.109,5.109,0,0,1,1.092,1.453c.284.517.407,1.484.646,2.063.149.362,1.362-2.833,1.362-2.833l-1.253-1.432,0,0-1.843.746",
    transform: "translate(-6184.747 -3259.906)",
    fill: "#d1e3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path572",
    d: "M1199.9-634.938a6.748,6.748,0,0,1,1.116,1.327,3.723,3.723,0,0,1,.623,1.72c.046.751,1.445-2.559,1.445-2.559l-1.337-1.528,0,0-1.843,1.038",
    transform: "translate(-6184.747 -3258.175)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserPic);
export default __webpack_public_path__ + "static/media/default_user_pic.58cea4bbab6fa4d6f591b42fe81adeb3.svg";
export { ForwardRef as ReactComponent };